// @ts-ignore
export const isMitren = import.meta.env.NUXT_PUBLIC_MITREN === 'true';

// ─── Services ────────────────────────────────────────────────────────────────

const SITE_CONFIG = {
  mibiotren: {
    ALLOWED_SERVICES: ['5', '6', '14'],
    ALLOWED_SERVICES_SLUG: ['laja-talcahuano', 'biotren', 'tren-araucania'],
    BASE_SITE: {
      NAME: 'MiBiotren',
      TITLE: 'MiBiotren.cl',
      URL: 'https://mibiotren.cl',
      IMAGE: 'https://mibiotren.cl/og-image.jpg',
      DESCRIPTION:
        'Consulta de horarios, tarifas y mapas del Biotren de Concepción, Coronel, Talcahuano, Chiguayante y Hualqui, todo sin instalar una APP',
    },
  },
  mitren: {
    ALLOWED_SERVICES: ['1', '2', '3', '5', '6', '9', '13', '14'],
    ALLOWED_SERVICES_SLUG: [
      'rancagua-estacion-central',
      'tren-chillan',
      'talca-constitucion',
      'laja-talcahuano',
      'biotren',
      'tren-san-fernando',
      'llanquihue-puerto-montt',
      'tren-araucania',
    ],
    BASE_SITE: {
      NAME: 'MiTren',
      TITLE: 'Mitren.cl',
      URL: 'https://mitren.cl',
      IMAGE: 'https://mitren.cl/og-image.jpg',
      DESCRIPTION:
        'Consulta de horarios, tarifas y mapas de todos los trenes de Chile, todo sin instalar una APP',
    },
  },
} as const;

const config = isMitren ? SITE_CONFIG.mitren : SITE_CONFIG.mibiotren;

export type TServiciosSlug = (typeof config.ALLOWED_SERVICES_SLUG)[number];
export type TServiciosId = (typeof config.ALLOWED_SERVICES)[number];

export const ALLOWED_SERVICES = config.ALLOWED_SERVICES;
export const ALLOWED_SERVICES_SLUG = config.ALLOWED_SERVICES_SLUG;
export const BASE_SITE = config.BASE_SITE;

// ─── Pairs maps ──────────────────────────────────────────────────────────────

export const ALLOWED_SERVICES_PAIRS_IDS: Map<TServiciosId, TServiciosSlug> =
  new Map(
    ALLOWED_SERVICES.map((srvId, i) => [srvId, ALLOWED_SERVICES_SLUG[i]!])
  );

export const ALLOWED_SERVICES_PAIRS: Map<TServiciosSlug, TServiciosId> =
  new Map(
    ALLOWED_SERVICES_SLUG.map((srvSlug, i) => [srvSlug, ALLOWED_SERVICES[i]!])
  );

// ─── Shared constants (unchanged between sites) ───────────────────────────────

export const BASE_SERVICIO_ID = '6' as const;
export const BASE_SERVICIO_SLUG = 'biotren' as const;
export const SERVICIOS_FERIADOS_OUT: TServiciosId[] = ['6'];

export const ESTACIONES_BASE_SERVICIOS = {
  'rancagua-estacion-central': '13',
  'tren-chillan': '26',
  'talca-constitucion': '18',
  'laja-talcahuano': '22',
  biotren: '35',
  'tren-san-fernando': '18',
  'llanquihue-puerto-montt': '4',
  'tren-araucania': '14',
} as const;

export const ESTACION_BASE_BIOTREN = 'concepcion';
export const ESTACION_BASE_BIOTREN_ID = '16';

export const SERVICES_MAP = [
  'biotren',
  'laja-talcahuano',
  'tren-araucania',
] as const;

export const SERVICES_MAP_GEO = {
  biotren: [-73.0613351, -36.8296658],
  'laja-talcahuano': [-73.0613351, -36.8296658],
  'tren-araucania': [-72.57872317825529, -38.73683453233111],
} as const;

export const DAYS = {
  'L-V': ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
  S: 'Saturday',
  D: 'Sunday',
} as const;

export const SEO: Record<string, { title: string; description: string }> = {
  'rancagua-estacion-central': {
    title: 'Tren Rancagua - Estación Central | Horarios y tarifas',
    description:
      'Revisa horarios, tarifas, estaciones y mapas del Tren Rancagua - Estación Central. Toda la información del servicio, fácil de encontrar.',
  },
  'tren-chillan': {
    title: 'Tren Chillán - Estación Central | Horarios y tarifas',
    description:
      'Consulta horarios, tarifas, estaciones y mapas del Tren Chillán - Estación Central. Información útil para planificar tu viaje en segundos.',
  },
  'talca-constitucion': {
    title: 'Talca - Constitución | Horarios, tarifas y estaciones',
    description:
      'Consulta horarios, tarifas, estaciones y mapas del servicio Talca - Constitución. Todo lo que necesitas para viajar sin buscar de más.',
  },
  'laja-talcahuano': {
    title: 'Corto Laja | Horarios, tarifas y estaciones',
    description:
      'Revisa horarios, tarifas, estaciones y mapas del servicio Corto Laja entre Talcahuano y Laja. Información clara para planificar tu viaje.',
  },
  biotren: {
    title: 'MiBiotren | Horarios, tarifas y estaciones',
    description:
      'Consulta horarios, tarifas, estaciones y mapas de Biotren de forma rápida y simple. Toda la información que necesitas, en un solo lugar.',
  },
  'tren-san-fernando': {
    title: 'San Fernando - Estación Central | Horarios y tarifas',
    description:
      'Revisa horarios, tarifas, estaciones y mapas del tren San Fernando - Estación Central. Información clara, directa y fácil de consultar.',
  },
  'llanquihue-puerto-montt': {
    title: 'Tren Llanquihue - Puerto Montt | Horarios y tarifas',
    description:
      'Revisa horarios, tarifas, estaciones y mapas del Tren Llanquihue - Puerto Montt. Acceso rápido a la ruta y sus paradas.',
  },
  'tren-araucania': {
    title: 'Tren Araucanía | Horarios, tarifas y estaciones',
    description:
      'Consulta horarios, tarifas, estaciones y mapas del Tren Araucanía entre Victoria y Temuco. Acceso rápido a la información del servicio.',
  },
};

export const DEFAULT_LIMIT = 10;
export const DEFAULT_THEME = 'dark';
export const MAX_AGE_COOKIE = 60 * 60 * 24 * 365;

/**
 * Maximum encoded size (bytes) allowed for the persisted `mb_user` value.
 *
 * Size is measured as `encodeURIComponent(JSON.stringify(fullPreferences)).length`,
 * which matches exactly what the browser stores as the cookie value. Cookie
 * attributes (name, `maxAge`, `path`, `sameSite`, `secure`) are NOT part of
 * the value and are excluded from this budget.
 *
 * When the serialized value would exceed this limit, size-enforcing helpers
 * evict the oldest saved station references (FIFO) to make room. Core fields
 * (`servicio`, `theme`, `limite`) are never evicted or truncated: if they
 * alone exceed this limit, the write is rejected instead of silently
 * discarding core data.
 */
export const MAX_COOKIE_SIZE = 3072;
